let count = 0;
import useRoomBaseServer from '../room/roombase.server';
import useGroupServer from '../group/StandardGroupServer';
import { safeJsonParse, truncateString } from '@/utils/index.js';
import { randomNumGenerator } from '@/utils/index.js';

const defaultAvatar = '';
export default class Msg {
  constructor(params) {
    const roomserver = useRoomBaseServer();
    const { avatar, role_name, user_id, third_party_user_id, nickname } = roomserver.state.watchInitData.join_info;
    //分组相关逻辑判断
    const { groupInitData = {} } = useGroupServer().state;
    this.data = {
      type: 'text',
      image_urls: []
    };
    this.context = {
      atList: [],
      replyMsg: {},
      avatar,
      nickname,
      role_name: groupInitData.isInGroup && groupInitData.join_role == 20 ? 20 : role_name,
      user_id: user_id || third_party_user_id,
      kick_id: roomserver.state.ssoKick?.kickId || sessionStorage.getItem('kickId') || '', // 如果为null传空字符串是为了解决ios客户端崩溃的问题。客户端升级6.4.0版本之后，该字段将无须前端再做兼容
      kick_mark: `${randomNumGenerator()}${roomserver.state.watchInitData.webinar.id}`,
    };
  }
  //设置私聊对象
  setTarget(targetId) {
    this.data.target_id = targetId;
    this.context.to = targetId;
  }
  //给消息添加文本
  setText(val) {
    this.data.barrageTxt = val.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br/>');
    this.data.text_content = val;
  }
  //是否跳过审核，有值就跳过
  setAccessAudit(val) {
    this.data.access_audit = val;
  }
  //给消息添加图片
  setImage(imglist) {
    if (imglist.length < 1) {
      this.data.type = 'text';
    } else {
      this.data.type = 'image'
    }
    this.data.image_urls = imglist;
  }
  //给消息添加回复相关信息
  setReply(replay = {}) {
    //TODO临时处理字段兼容（v3接口约定的暂不可更改）
    replay.nickName = replay.nickname;
    this.context.replyMsg = replay;
  }
  //给消息添加@相关信息
  setAt(atlist = []) {
    this.context.atList = atlist;
    console.log(atlist);
  }
  setLevel(level) {
    if (level > 0) {
      this.context.member_level = level;
    } else if (Object.prototype.hasOwnProperty.call(this.context, 'member_level')) {
      this.context.member_level = undefined;
    }
  }
  //对外暴露消息key
  static getcount() {
    return ++count;
  }

  //私有方法，组装消息用于渲染（暂时按照的h5版本的,大致数据一致，具体业务逻辑操作有差异，后续返回一个promise，并返回未处理的原始数据，由视图自己决定如何处理）
  static _handleGenerateMsg(item = {}, isHistoryMsg) {
    let resultMsg = {
      type: item.data.type,
      avatar: item.context.avatar || defaultAvatar,
      sendId: item.sender_id || item.sourceId || item.context.user_id,
      showTime: item.showTime || item.context.showTime,
      nickname: item.nickname || item.context.nickname || item.context.nick_name,
      roleName: item.context.role_name,
      extra_identity: item.context.extra_identity,
      is_chatbot: item.context.is_chatbot,
      sendTime: item.date_time,
      content: item.data,
      replyMsg: item.context.replyMsg || item.context.reply_msg || {},
      atList: item.context.atList || [],
      msgId: item.msg_id,
      channel: item.channel_id,
      isHistoryMsg: isHistoryMsg,
      count: ++count,
      client: item.client,
      member_level: item.context.member_level,
      kick_id: item.context.kick_id,
      kick_mark: item.context.kick_mark
    };
    // console.log('---resultMsg----->>-', item, resultMsg);
    const isNicknameEncryption = useRoomBaseServer().state.configList['chat_nickname_encryption'];
    // 昵称是否加密, 只对观众有效
    if (isNicknameEncryption && resultMsg.roleName == 2 && item.msgId) {
      const { watchInitData } = useRoomBaseServer().state;
      if (resultMsg.sendId != watchInitData.join_info.third_party_user_id) {
        // 不是自己发的消息, 加密处理
        resultMsg.nickname = (resultMsg.nickname || '').substring(0, 1) + '**';
      }
    }

    if (item.data.event_type) {
      resultMsg = {
        ...resultMsg,
        type: item.data.event_type,
        event_type: item.data.event_type,
        content: {
          source_status: item.data.source_status,
          gift_name: item.data.gift_name,
          gift_url: item.data.gift_url
        }
      };
    }

    // 20250603 聊天列表中增加其它(非聊天)类型消息
    if (resultMsg.type === 'system_notice') {
      let textContent = safeJsonParse(item.data?.text_content);
      switch (textContent?.type) {
        // 礼物消息结构转换
        case 'gift_send_success':
          resultMsg.showTime = ''; // 礼物消息不显示时间
          resultMsg.nickname = truncateString(textContent.gift_user_nickname || resultMsg.nickname || '', 8);
          resultMsg.type = textContent.type;
          resultMsg.interactToolsStatus = true;
          resultMsg.content = {
            gift_name: textContent.gift_name || '',
            gift_url: `${textContent.gift_image_url || textContent.gift_url || ''}`,
            source_status: textContent.source_status
          }
          break
        // NOTE: 如果后续有需求，可以在这里追加其它类型的消息结构转换
        default:
          // 所有不支持的类型处理
          resultMsg.showTime = '';
          resultMsg.type = 'unsupported'
          resultMsg.content = ''
      }
    }
    return resultMsg;
  }
}
